import { LoadPanel } from "devextreme-react";
import { useCallback } from "react";
import { useSelector } from "react-redux";
import { store } from "../store/store";
import {
  selectLoadPanelVisible,
  setLoadPanelVisible,
} from "../redux/shareSlice";

const Loader = () => {
  const loadPanelVisible: boolean = useSelector(selectLoadPanelVisible);

  const hideLoadPanel = useCallback(() => {
    store.dispatch(setLoadPanelVisible(false));
  }, []);

  return (
    <LoadPanel
      shadingColor="rgba(0,0,0,0.4)"
      onHiding={hideLoadPanel}
      visible={loadPanelVisible}
      showIndicator={true}
      shading={true}
      showPane={true}
    />
  );
};

export default Loader;
